<template>
    <div>
        <b-container>
            <b-card class="bg-template shadow mt-4 h-150">
                <b-row>
                    <b-col cols="auto" class="pr-1">
                        <figure class="avatar avatar-60">
                            <img :src="user.photo ? '/'+user.photo : '/img/user-default.png'"
                                 :alt="(user.name + ' ' + user.lname).replace(',', '')"
                                 :title="(user.name + ' ' + user.lname).replace(',', '')">
                        </figure>
                    </b-col>
                    <b-col class="pl-2">
                        <h5 class="mb-1">{{ (user.name + ' ' + user.lname).replace(',', '') }}</h5>
                        <p class="text-mute small mb-0">Última Conexión:
                            {{ new Date((''+user.last_access).replace(/ /g,"T")) | moment("DD/MM/YYYY HH:mm") }}</p>
                        <p class="text-mute small">IP: {{ user.ip }}</p>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>
        <b-container class="top-60">
            <b-card class="mb-4 shadow">
                <b-row>
                    <b-col>
                        <h3 class="mb-1 font-weight-normal">$ {{ Number(statistics.amount).toLocaleString("en-US") + ' ' + statistics.currency }}</h3>
                        <p class="text-mute ml-2">Mi Saldo</p>
                    </b-col>
                    <b-col cols="auto">
                        <b-button variant="default" class="btn-rounded-54 shadow" v-if="user.role === 'Partner'" v-b-modal.add>
                            <i class="material-icons">add</i>
                        </b-button>
                    </b-col>
                </b-row>
            </b-card>

            <!-- Modal Add Money Partner -->
            <b-modal
                id="add"
                centered
                header-class="text-center"
                header-text-variant="primary"
                header-close-variant="primary"
                footer-class="border-0"
                hide-footer
                body-class="text-center px-4 pt-0 mb-4"
                title="Agregar Saldo"
                tabindex="-1"
                role="dialog"
                aria-hidden="true"
                v-if="user.role === 'Partner'">
                <img :src="'/img/salary.png'" alt="logo" class="logo-small mb-3">
                <b-form id="add_money" @submit.stop.prevent="add()">
                    <b-row class="justify-content-center">
                        <b-col cols="12" md="9" align-self="start">
                            <b-form-group :label="labels.value+':'">
                                <b-input-group>
                                    <template #prepend>
                                        <b-input-group-text class="m-0 px-sm-4 btrr-0 bbrr-0"><b>{{ form.currency === 'PEN' ? 'S/.' : '$' }}</b></b-input-group-text>
                                    </template>
                                    <currency-input
                                        v-model="form.value"
                                        name="value"
                                        v-validate="'required:true'"
                                        :state="validateState('value')"
                                        aria-describedby="value-live-feedback"
                                        :data-vv-as="(labels.value).toLowerCase()"
                                        :disabled="loading"
                                        :precision="currency_precision"
                                        class="text-right text-sm-center form-control form-control-lg"
                                        style="padding: 0.5rem 1rem; background-image: none;"/>
                                    <template #append>
                                        <b-dropdown :text="form.currency" variant="default" right class="m-0 btlr-0 bblr-0" toggle-class="px-sm-4">
                                            <template v-for="item in currencies">
                                                <b-dropdown-item @click="form.currency = item.code">{{ item.code + ' - ' + item.name }}</b-dropdown-item>
                                            </template>
                                        </b-dropdown>
                                    </template>
                                </b-input-group>
                                <b-form-invalid-feedback id="value-live-feedback">{{ veeErrors.first('value') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="9" align-self="start">
                            <b-form-group :label="labels.voucher+':'" label-align="center">
                                <b-form-file
                                    name="voucher"
                                    v-model="form.voucher"
                                    v-validate="'required:true|image|size:10240'"
                                    :data-vv-as="(labels.voucher).toLowerCase()"
                                    aria-describedby="voucher-live-feedback"
                                    :state="form.voucher ? Boolean(form.voucher) : form.voucher || validateState('voucher')"
                                    placeholder="Seleccione un archivo ..."
                                    drop-placeholder="Suelta el archivo aquí ..."
                                    accept="image/*"
                                    browse-text="Buscar"
                                    size="lg"
                                ></b-form-file>
                                <b-form-invalid-feedback id="voucher-live-feedback">{{ veeErrors.first('voucher') }}</b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="10" align-self="start" class="my-4">
                            <b-button type="submit" variant="default" size="lg" pill class="shadow align-middle px-5" form="add_money" :disabled="loading">
                                <b-spinner small type="grow" v-if="loading"></b-spinner>
                                <b-icon icon="wallet2" aria-hidden="true" class="align-middle" v-else></b-icon>
                                &nbsp;&nbsp;<span>{{ loading ? 'Enviando...' : 'Enviar' }}</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-modal>
        </b-container>
        <b-container>
            <h6 class="subtitle px-2">Giros Recientes <a class="float-right small" @click="getLink('PartnerHistory')"><b>Ver Todos</b></a></h6>
            <template v-if="!loading">
                <div class="card shadow border-0 mb-3" v-for="item in payments" v-if="payments" v-bind:key="item.id">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <p class="text-mute small text-secondary mb-2"><b>ID:</b> {{ item.id }}<span class="float-right">{{ new Date((''+item.date).replace(/ /g,"T")) | moment("DD/MM/YYYY hh:mm A") }}</span></p>
                                <p class="text-mute small text-secondary mb-2">{{ Number(item.amount_send).toLocaleString("en-US") + ' ' + item.currency_send }} ➤ {{ Number(item.amount_receiver).toLocaleString("en-US") + ' ' + item.currency_receiver }}</p>
                                <div class="progress h-4">
                                    <div :class="'progress-bar bg-'+item.color" role="progressbar" :style="'width:'+item.value+'%'" :aria-valuenow="item.value" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="col-auto pl-0">
                                <b-avatar button size="50" :variant="item.color" class="no-shadow border-0 bg-template" @click="getLink('PartnerDetails', item.id)" icon="eye-fill"></b-avatar>
                            </div>
                        </div>
                    </div>
                </div>
                <h6 class="text-secondary text-center pt-3" v-else>No hay transacciones recientes</h6>
            </template>
            <template v-else>
                <b-card class="card shadow border-0 mb-3" v-for="(k, i) in list" v-bind:key="k.id">
                    <b-skeleton :id="k+i" animation="fade" width="85%"></b-skeleton>
                    <b-skeleton :id="k+i" animation="fade" width="55%"></b-skeleton>
                    <b-skeleton :id="k+i" animation="fade" width="70%"></b-skeleton>
                </b-card>
            </template>
        </b-container>
    </div>
</template>

<script>
import axios from "axios";
import {CurrencyInput} from 'vue-currency-input';

export default {
    name: "PartnerHome",
    props: [ 'user' ],
    components: { CurrencyInput },
    data: () => ({
        loading: true,
        payments: [],
        list: [
            { id: 1 },
            { id: 2 },
            { id: 3 },
            { id: 4 },
            { id: 5 }
        ],
        statistics: {
            amount: 0,
            currency: 'USD'
        },
        labels: {
            value: 'Valor Deposito',
            voucher: 'Comprobante de Pago'
        },
        form: {
            value: 0,
            currency: 'USD',
            voucher: null
        },
        currencies: [
            { code: 'USD', country: 'CL', name: 'Dolares' }
        ],
        currency_precision: 0
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'homepage');
        this.getIni();
    },
    watch: {
        'user.partner'() {
            clearTimeout(this.timeout);
            this.getIni();
        }
    },
    methods: {
        getIni() {
            axios.get('/api/partner/home').then((res) => {
                if (res.data.status === 'success') {
                    this.statistics = res.data.statistics;
                    this.payments = res.data.payments;
                    this.$emit('success');
                } else {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
            this.timeout = setTimeout(this.getIni, 180000);
        },
        getLink(route, id) {
            this.$router.push({ name: route, params: { id: id } });
        },
        add() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;

                let formData = new FormData();

                formData.append('partner_id', this.user.partner);
                formData.append('amount', this.form.value);
                formData.append('currency', this.form.currency);
                formData.append('voucher', this.form.voucher);

                axios.post('/api/partner/add', formData, {
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(res => {
                    if (res.data.status === 'success') {
                        this.getIni();
                        this.form = {
                            value: 0,
                            currency: 'USD',
                            voucher: null
                        };
                        this.$validator.reset();
                        this.$emit('success');
                        this.$bvModal.hide('add');
                    }
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>
.logo-small {
    width: 128px;
}
</style>
